/* app short link */

export const APP_HOME = 'msport://main?page=Msport'
export const APP_SETTINGS = 'msport://settings'
export const APP_UPGRADE = 'msport://upgrade_to_appstore'

// app login, force 参数是 IOS team 所要求
export const APP_LOGIN = 'msport://login?force=1'
export const APP_SIGNUP = 'msport://regist'
export const APP_FORGOT_ACCOUNT = 'msport://forgot_account'
export const APP_ACCOUNT = 'msport://my_account'
export const APP_ME = 'msport://me'
export const APP_VOUCHER = 'msport://voucher'

/* realsport */
export const APP_LIVE_LIST = 'msport://live_list'
export const APP_SPORT_LIST = 'msport://sport_list'
export const APP_MATCH_DETAIL = 'msport://match_detail'
export const APP_CODE_LIST = 'msport://code_list'
export const APP_ORDER_DETAILS = 'msport://settled_details'
export const APP_JACKPOT_ORDER_DETAILS = 'msport://jackpot_order_details'

/* virtual */
export const APP_VIRTUAL_BET_HISTORY = 'msport://virtual_bet_history'

/* pay */
export const APP_DEPOSIT = 'msport://deposit'
export const APP_WITHDRAW = 'msport://withdraw'
export const APP_TRANSACTION = 'msport://transaction'
export const APP_TRANSACTION_DETAILS = 'msport://transaction_details'

/* games */
// app 游戏大厅
export const APP_GAMES = 'msport://game_aggregate'
export const APP_SUPER_KICK = 'msport://game_super_kick'
export const APP_MAD_PUNCH = 'msport://game_mad_punch'
export const APP_SPIN = 'msport://roulette'
